import {
    HavePrescriptionMemoCancelModalText,
    InfoBodyUserResponsesText,
    MindUpAdminHavePrescriptionMemoCancelModalText,
    MindUpAdminNotPrescriptionMemoCancelModalText,
    MindUpResponseByQuestionText,
    NotPrescriptionMemoCancelModalText,
} from 'constants/viewDetailDiagnosisPageConstants';
import { AccountLevel } from './statusCode';

/**
 * @TOOD 추후 병원 타입으로 구분해야함
 * @param hospitalId 병원 아이디
 * 상담 스트링 및 상담병원 여부
 */
export const getConsultationTypeStr = (loginLevel: number) => {
    return loginLevel === AccountLevel.externalCounselor ? '상담' : '진료';
};

export const isConsultationHospital = (hospitalId: string) => {
    return hospitalId === '677e22fe3d73c33a066fc54a' || hospitalId === '67d14e8c564cfdb75af9a281';
};

export const getResponseByQuestionText = (type: number) => {
    switch (type) {
        case 20:
            return MindUpResponseByQuestionText;
        default:
            return InfoBodyUserResponsesText;
    }
};

export const getRelationTypeStr = (relationType?: number) => {
    switch (relationType) {
        case 0:
            return '엄마';
        case 1:
            return '아빠';
        case 2:
            return '기타';
        default:
            return '-';
    }
};

export const getCancelMemoText = (type: number, memo: string) => {
    if (memo) {
        switch (type) {
            case 20:
                return MindUpAdminHavePrescriptionMemoCancelModalText;
            default:
                return HavePrescriptionMemoCancelModalText;
        }
    } else {
        switch (type) {
            case 20:
                return MindUpAdminNotPrescriptionMemoCancelModalText;
            default:
                return NotPrescriptionMemoCancelModalText;
        }
    }
};
